
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { TermsAndConditionsContest } from './terms_contest';
import ReactMarkdown from 'react-markdown';

const TermsContest = () => {
  return (
    <Box>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          py: 3,
          gap: 1.5,
          '& ol li ol li::marker': {
            color: theme => theme.palette.text.secondary,
          }
        }}
      >
        <Typography variant='h5' sx={{whiteSpace: 'pre-line'}}>
          Soopra.ai AI Persona Creation Contest – Terms & Conditions
        </Typography>

        <Typography variant='h7' sx={{whiteSpace: 'pre-line'}}>
          {TermsAndConditionsContest.title}
        </Typography>

        <Typography variant='body1' color='text.secondary' sx={{whiteSpace: 'pre-line'}}>
          <ReactMarkdown className={`markdown`}>
            {TermsAndConditionsContest.description}
          </ReactMarkdown>
        </Typography>

        <ol className='terms-list' style={{paddingLeft: '32px'}}>
          {TermsAndConditionsContest.listItems.map((item, index) => (
            <TermListItem key={`terms-${index}`} item={item} idx={`terms-${index}`} />
          ))}
        </ol>
      </Container>
    </Box>
  );
};

const TermListItem = (props: any) => {
  let item = props.item;
  let idx = props.idx;

  return (
    <li style={{ paddingBottom: '8px' }}>
      <Typography variant='h7' sx={{pb: 0.5}}>
        {item?.title}
        {
          item?.description &&
            <Typography
              variant='body1'
              color='text.secondary'
              component={'span'}
              sx={{ whiteSpace: 'pre-line'}}
            >
              <ReactMarkdown className={`markdown`}>
                {item?.description}
              </ReactMarkdown>
            </Typography>
        }
      </Typography>

      {item?.listItems &&
        <ol style={{paddingLeft: '32px', paddingBottom: '4px'}}>
          {
            item.listItems.map((text, index) => (
              <li
                key={`${idx}-${index}`}
              >
                <Typography
                  variant='body1'
                  color='text.secondary'
                  component={'span'}
                  sx={{ whiteSpace: 'pre-line'}}
                >
                  <ReactMarkdown className={`markdown`}>
                    {text}
                  </ReactMarkdown>
                </Typography>
              </li>
            ))
          }
        </ol>
      }

      {
        item?.footer &&
        <Typography
          variant='body1'
          color='text.secondary'
          component={'span'}
          sx={{ whiteSpace: 'pre-line', pb: 0.5}}
        >
          {item?.footer}
        </Typography>
      }
    </li>
  )
}

export default TermsContest;
